import { gql } from '@apollo/client'

export const KANBAN_QUERY = gql`
  query Kanban {
    kanban: d4_kanban {
      id
      titre
      etatkanbans {
        id
        libelle
        numeroordre
        dureeexpirationpardefaut
        datafield
        etatkanbansuivant_id
        couleuretatkanban
        kanban_id
      }
    }
  }
`
